import type { ProductUpdatesEnvironment } from './interface';

export const environment: ProductUpdatesEnvironment = {
  production: false,
  angularProdMode: true,
  apiUrl: 'https://api.groundcontrol.tellent.com/v1',
  baseUrl: 'https://updates.tellent.com',
  i18n: {
    defaultLocale: 'en',
    availableLocales: ['en', 'de', 'nl', 'fr'],
  },
};
